import { render, staticRenderFns } from "./businessprivacy.vue?vue&type=template&id=75d59a65&"
import script from "./businessprivacy.vue?vue&type=script&lang=js&"
export * from "./businessprivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports